import React from "react";
import "./CSS/Others.css";

const Others = () => {
    return (
        <section className="webdev">
           <h1> Others News</h1>
           
        </section>
    );
};

export default Others;
